class ProductDetailFaqs extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.triggerEl, 'click', this.onClick.bind(this))
  }

  onClick (e) {
    e.preventDefault()

    const boundingRect = this.faqsEl.getBoundingClientRect()
    const distanceFromTopOfPage = window.scrollY + boundingRect.top
    const announcementBar = document.querySelector('header-announcement-bar')
    const announcementBarHeight =
      announcementBar !== null ? announcementBar.offsetHeight : 0
    const headerHeight = document.querySelector('.hd-Header').offsetHeight
    const combinedHeight = announcementBarHeight + headerHeight

    window.BAO.Utils.scrollToY(distanceFromTopOfPage - combinedHeight)
  }

  get triggerEl () {
    return this.els.trigger.element
  }

  get faqsEl () {
    return this.externalEls.pdpFaqs.element
  }
}

if (!customElements.get('product-detail-faqs')) {
  customElements.define('product-detail-faqs', ProductDetailFaqs)
}
